module.exports = __webpack_public_path__ + "img/win.2f4e38df.svg";